import { render, staticRenderFns } from "./ScreenDetallePunto.vue?vue&type=template&id=4ea624bc"
import script from "./ScreenDetallePunto.vue?vue&type=script&lang=js"
export * from "./ScreenDetallePunto.vue?vue&type=script&lang=js"
import style0 from "./ScreenDetallePunto.vue?vue&type=style&index=0&id=4ea624bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports